export default "__VITE_ASSET__CNs0$5Tr__"